import React, { useEffect, useState, useCallback } from "react";
import { FaEye, FaFilter } from "react-icons/fa6";
import { capitalizeWords } from "../../../../../utils/common";
import { Role } from "../../../../../constants/role";

import { DataTable } from "../../../../common";
import { IconMenuOption } from "../../../../controls";

const MobileUsersList = ({
  mobileUserList,
  userRole,
  selectedRowsData,
  subscriptionList,
  onClickSubscriptionDropDownFilterOptions,
  persistedData,
  onClickViewUser,
  handleTableRowsChange,
  handleChangePage,
  currentPage,
  sendNotificationForAllCheckbox,
  showSelection,
  memoizedHandleSelectedRows,
}) => {
  const renderSubscriptionColumnHeader = (label) => {
    return (
      <div className="custom-column-header">
        <text>{label}</text>
        {userRole !== Role.Viewer && (
          <div className="sortIcon">
            {selectedRowsData?.length === 0 && (
              <IconMenuOption
                menuIcon={<FaFilter />}
                options={subscriptionList}
                name={"name"} //object contain "status" field ==> this is to access from iconMenuOption component
                showMenuOptions={true}
                onClickFilterOption={onClickSubscriptionDropDownFilterOptions}
                persistedData={persistedData?.subscription}
                multipleFilterAllowed={true}
              />
            )}
          </div>
        )}
      </div>
    );
  };

  // const renderCommaSeparatedTopics = (topicMappingCollectionId) => {
  //   if (!topicMappingCollectionId || topicMappingCollectionId.length === 0)
  //     return "-"; // Return "-" if no topics

  //   return topicMappingCollectionId
  //     .map((topic) => topic.topicId?.name || "")
  //     .filter((name) => name) // Filter out any empty or undefined names
  //     .join(", ");
  // };

  const renderCommaSeparatedTopics = (topicMappingCollectionId) => {
    if (!topicMappingCollectionId || topicMappingCollectionId.length === 0) {
      return "-"; // Return "-" if no topics
    }

    return topicMappingCollectionId
      .map((topic) => topic.name || "") // Access the 'name' property directly
      .filter((name) => name) // Filter out any empty or undefined names
      .join(", ");
  };

  // const renderCommaSeparatedSubscriptions = (subscriptions) => {
  //   if (!subscriptions || subscriptions.length === 0) return "-"; // Return "-" if no subscriptions

  //   return subscriptions
  //     .map(
  //       (sub) =>
  //         `${sub.name || ""}${
  //           sub.subscriptionOfferingName
  //             ? ", " + sub.subscriptionOfferingName
  //             : ""
  //         }`
  //     )
  //     .join(", ");
  // };

  //--------------------------action UI

  const renderActionMenu = (row) => {
    const menuList = [
      {
        icon: <FaEye size={15} color="#B6C7AA" title="View" />,

        onclick: () => {
          onClickViewUser(row);
          // history?.push(`/mobile-app-users/user-details/${row?._id}`);
        },
      },
      // userPermissions?.includes("edit_user") && {
      //   icon: <FaPen size={15} color="#4B70F5" title="Edit" />,

      //   onclick: () => {
      //     onClickEditUser(row);
      //   },
      // },
      // userPermissions?.includes("delete_user") && {
      //   icon: <MdDelete size={15} color="#FF0000" title="Delete" />,

      //   onclick: () => {
      //     onClickDeleteUser(row);
      //   },
      // },
    ];

    return (
      <div className="action-menu-wrapper d-flex gap-3">
        {menuList.map((item) => {
          return (
            <div className="menu-item" onClick={item?.onclick}>
              {item?.icon}
            </div>
          );
        })}
      </div>
    );
  };

  const columns = [
    {
      name: "Name",
      // width: "27.5%",
      // width: "23.8%",
      width: "20%",
      selector: (row) => capitalizeWords(row?.name) || "-",
    },
    {
      name: "Email",
      // width: "30%",
      width: "30%",
      selector: (row) => row?.email || "-",
    },
    {
      name: "Status",
      // width: "12.5%",
      width: "12%",
      selector: (row) => row?.status || "-",
    },
    {
      name: renderSubscriptionColumnHeader("Subscription"),
      // width: "20%",
      selector: (row) =>
        renderCommaSeparatedTopics(
          row?.customParameters?.topicMappingCollectionId
        ),
      // selector: (row) => renderCommaSeparatedSubscriptions(row?.subscriptions),
    },
    {
      name: "Action",
      width: "10%",
      center: true,
      // cell: (row, rowIndex) => renderAction(row, rowIndex),
      cell: (row, rowIndex) => renderActionMenu(row, rowIndex),
    },
  ];

  const customStyles = {
    cells: {
      style: {
        width: "100px",
      },
    },
  };

  return (
    <>
      <DataTable
        keyField={"_id"}
        columns={columns}
        data={mobileUserList?.docs ? mobileUserList?.docs : []}
        highlightOnHover={true}
        pointerOnHover={true}
        fixedHeader={true}
        //
        pagination={true}
        paginationServer={true}
        paginationPerPage={mobileUserList?.limit}
        paginationTotalRows={mobileUserList?.totalDocs}
        onChangeRowsPerPage={handleTableRowsChange}
        onChangePage={handleChangePage}
        currentPage={currentPage}
        //
        selectableRows={!sendNotificationForAllCheckbox && showSelection}
        clearSelectedRows
        onSelectedRowsChange={memoizedHandleSelectedRows}
        //
        customStyles={customStyles}
      />
    </>
  );
};

export default MobileUsersList;
